module.exports = __webpack_public_path__ + "img/bd.8b3f06e9.png";